import { FastField, getIn, useFormikContext } from "formik";
import React, { useEffect, useRef } from "react";
import { theme } from "../../../../Customization/Theme";
import { useAppSelector } from "../../../../Store";
import {
  InputAndUploadWrap,
  StyledInputField,
  StyledUploadedMediaBox,
  StyledWidgetInputBox,
} from "../../../Styles/StyledForms";

import { allMessagesStore } from "../../../../Store/Slices/socket/AllMessagesSlice";
import { socketStatusStore } from "../../../../Store/Slices/socket/SocketSlice";
import { useBotConfigStore } from "../../../../Store/Slices/ChatbotSlices/BotConfigSlice";
import { SOCKET_CONNECTION_TYPES } from "../../../utils/Enum";
import AppErrorMessage from ".././AppErrorMessage";
import AppSendSubmitButton from ".././AppSendSubmitButton";
import EditorMediaUpload from "./EditorMediaUpload";
import { AppMaterialIcons } from "../../Icons";
import { Box, Divider, IconButton } from "@mui/material";
import AppVoiceButton from "../AppVoiceButton";

interface Props {
  name?: string;
  label?: string;
  children?: React.ReactNode;
  showVoiceButton?: boolean;
  [otherProps: string]: any;
  ref?: any;
}

const AppFlowLiveChatField: React.FC<Props> = ({
  name = "livechat",
  label = "Enter message",
  showVoiceButton = false,
  children,
  ...otherProps
}) => {
  const {
    errors,
    touched,
    values,
    handleChange,
    setFieldValue,
    setFieldError,
    handleSubmit,
  } = useFormikContext<any>();
  const { typingStatus, sessionId, liveChatConnected } = useAppSelector(allMessagesStore);
  const { socket } = useAppSelector(socketStatusStore);
  const { botConfig } = useAppSelector(useBotConfigStore);
  // Single feature flag gating all recent bot enhancements.
  const enhancedBot = botConfig?.config?.enhanced_bot ?? false;
  // useTypingStatus(socket)
  const inputRef: any = useRef<any>();

  // Let the user end the active live-agent session and return to the bot (same session).
  const handleEndLiveChat = () => {
    if (socket && sessionId) {
      socket.emit(SOCKET_CONNECTION_TYPES.CHAT_END_BY_USER, {
        session_id: sessionId,
      });
    }
  };

  useEffect(() => {
    if (inputRef?.current && !typingStatus) {
      inputRef?.current?.focus();
    }
  }, [inputRef, typingStatus]);
  useEffect(() => {
    if (inputRef?.current) {
      inputRef?.current?.focus();
    }
  }, [getIn(values, "media")]); // eslint-disable-line react-hooks/exhaustive-deps

  // console.log("getIn(values", getIn(values, "media"), getIn(errors, "media"));


  const handleVoiceInput = (text: string) => {
    setFieldValue(name, text);
    // Automatically submit the form after voice input
    setTimeout(() => {
      handleSubmit();
    }, 100);
  };

  return (
    <>
      {enhancedBot && liveChatConnected ? (
        <Box style={{ display: "flex", justifyContent: "center", marginBottom: "4px" }}>
          <button
            type="button"
            onClick={handleEndLiveChat}
            style={{
              background: "transparent",
              border: "none",
              color: "#d32f2f",
              cursor: "pointer",
              fontSize: "12px",
              textDecoration: "underline",
              padding: "2px 8px",
            }}
          >
            End live chat
          </button>
        </Box>
      ) : null}
      {getIn(errors, "media") ? (
        <StyledUploadedMediaBox style={{ border: "1px solid red" }}>
          <p>{getIn(errors, "media")}</p>
          <IconButton
            title={"Clear"}
            onClick={() => {
              setFieldValue("media", null);
              setFieldError("media", undefined);
            }}
          >
            <AppMaterialIcons iconName={"Close"} />
          </IconButton>
        </StyledUploadedMediaBox>
      ) : null}
      {getIn(values, "media")?.name && getIn(values, "media")?.source ? (
        <StyledUploadedMediaBox>
          <p>{getIn(values, "media")?.name}</p>
          <IconButton
            title={"Clear"}
            onClick={() => setFieldValue("media", null)}
          >
            <AppMaterialIcons iconName={"Close"} />
          </IconButton>
        </StyledUploadedMediaBox>
      ) : null}
      <StyledWidgetInputBox
        disabled={typingStatus ? true : false}
        error={getIn(errors, name) && getIn(touched, name)}
      >
        <InputAndUploadWrap>
          <FastField name={name}>
            {({ field }: any) => (
              <StyledInputField
                style={{
                  paddingRight: "50px"
                }}
                {...otherProps}
                {...field}
                value={getIn(values, name) || ""}
                onChange={(e: any) => {
                  handleChange(e);
                }}
                ref={inputRef}
                placeholder={label}
                autoFocus={true}
              />
            )}
          </FastField>
          <EditorMediaUpload />
        </InputAndUploadWrap>
        {showVoiceButton ? (
          getIn(values, name)?.length > 0 ? (
            <AppSendSubmitButton />
          ) : (
            <AppVoiceButton onVoiceInput={handleVoiceInput} />
          )
        ) : (
          <AppSendSubmitButton />
        )}
        {/* <AppSendSubmitButton /> */}
        <AppErrorMessage
          error={getIn(errors, name)}
          visible={getIn(touched, name)}
        />
      </StyledWidgetInputBox>
    </>
  );
};

export default AppFlowLiveChatField;
